import React, { ReactNode, useCallback, useEffect, useRef } from 'react';

interface IProps {
  className?: string;
  onOutsideClick: () => void;
  children: ReactNode;
}
const OutsideClickWrapper = ({
  className = '',
  onOutsideClick,
  children,
}: IProps) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  const handleClickOutside = useCallback(
    (event) => {
      if (!document.body.contains(event.target)) return;

      if (wrapperRef.current && !wrapperRef.current?.contains(event.target)) {
        onOutsideClick();
      }
    },
    [onOutsideClick]
  );

  const handleKeyPress = useCallback(
    (event) => {
      if (event.key === 'Escape') {
        onOutsideClick();
      }
    },
    [onOutsideClick]
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [handleClickOutside, handleKeyPress]);

  return (
    <div ref={wrapperRef} className={className}>
      {children}
    </div>
  );
};

export default OutsideClickWrapper;
